import { ElementRef, OnInit, Renderer2, } from "@angular/core";
import { fromEvent } from "rxjs";
import { ConfigureService } from "../../../configure/configure.service";
var GoogleMapsStaticComponent = /** @class */ (function () {
    function GoogleMapsStaticComponent(configService, renderer) {
        this.configService = configService;
        this.renderer = renderer;
        this.url = "";
        this._config = undefined;
    }
    Object.defineProperty(GoogleMapsStaticComponent.prototype, "config", {
        get: function () {
            return this._config;
        },
        set: function (config) {
            if (config) {
                this._config = config;
                this.generateStaticMapUrl(true);
            }
        },
        enumerable: true,
        configurable: true
    });
    GoogleMapsStaticComponent.prototype.ngOnInit = function () {
        var _this = this;
        // get new static map if window is resized
        fromEvent(window, "resize").subscribe(function (_) {
            _this.generateStaticMapUrl(true);
        });
    };
    GoogleMapsStaticComponent.prototype.generateStaticMapUrl = function (changeMapSize) {
        if (this.config) {
            var containerStyles = getComputedStyle(this.elContainer.nativeElement);
            var mapWidth = void 0;
            var mapHeight = void 0;
            if (this.config.size) {
                var mapSizeArr = this.config.size.split("x");
                // changing map width to be container's width so map will be request with the right proportion
                // changeMapSize equals false for unit testing purpose as we're unable to check styles width
                mapWidth = changeMapSize
                    ? containerStyles.width.replace("px", "")
                    : mapSizeArr[0];
                mapHeight = mapSizeArr[1];
            }
            // forcing map/image to have the height set by the config object otherwise will change due to proportion
            this.renderer.setStyle(this.el.nativeElement, "height", mapHeight + "px");
            // optional parameters zoom and markerColor
            var zoom = this.config.zoom ? "zoom=" + this.config.zoom + "&" : "";
            var markerColor = this.config.markerColor
                ? "color:" + this.config.markerColor + "|"
                : "";
            // setting size depending on mapWidth and mapHeight
            var size = Math.round(mapWidth) + "x" + mapHeight;
            // tslint:disable-next-line:max-line-length
            this.url = this.configService.params.googleMapsDomain + "/maps/api/staticmap?" + zoom + "size=" + size + "&markers=" + markerColor + this.config.latitude + "," + this.config.longitute + "&key=" + this.configService.params.googleMapsAPIkey;
        }
    };
    return GoogleMapsStaticComponent;
}());
export { GoogleMapsStaticComponent };
